export default __webpack_public_path__ + "static/media/place1.fdacadac.jpg";